"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.THRESHOLD = exports.MODE = void 0;
var MODE;
(function (MODE) {
    MODE["DEFAULT"] = "default";
    MODE["ONCE"] = "once";
    MODE["BYPIXELS"] = "byPixel";
})(MODE = exports.MODE || (exports.MODE = {}));
var THRESHOLD;
(function (THRESHOLD) {
    THRESHOLD[THRESHOLD["FULL"] = 1] = "FULL";
    THRESHOLD[THRESHOLD["HALF"] = 0.5] = "HALF";
    THRESHOLD[THRESHOLD["BEARLY"] = 0] = "BEARLY";
})(THRESHOLD = exports.THRESHOLD || (exports.THRESHOLD = {}));
